export default "__VITE_ASSET__BjbW3q50__"